import request from '@/utils/request'

/**
 * 这是通用的js，这里有一些经常用到的请求
 **/

/** 获取购物车数据 */
export function getCarData (params) {
  return request({
    url: '/shoppingCart/web/pageShoppingCart',
    method: 'get',
    params: params
  })
}

/** 添加购物车 */
export function saveCar (productData) { // 获取token
  return request({
    url: '/shoppingCart/web/save',
    method: 'post',
    data: productData
  })
}

export function removeCar (idArray) {
  return request({
    url: '/shoppingCart/web/asyncDelete',
    method: 'post',
    params: {
      shoppingCartIds: idArray.join(',')
    }
  })
}
// import request from '@/utils/request'

/**
 * 这是通用的js，这里有一些经常用到的请求
 **/

/** 获取购物车数据 */
// export function getCarData (params) {
//   return request({
//     url: '/shoppingCart/web/pageShoppingCart',
//     method: 'get',
//     params: params
//   })
// }

/** 添加购物车 */
// export function saveCar (productData) { // 获取token
//   return request({
//     url: '/shoppingCart/web/save',
//     method: 'post',
//     data: productData,
//   })
// }
// 删除购物车 shoppingCart/web/asyncDelete
// export function removeCar (idArray) {
//   return request({
//     url: '/shoppingCart/web/asyncDelete',
//     method: 'post',
//     params: {
//       shoppingCartIds: idArray.join(',')
//     }
//   })
// }
// 收藏购物车 productCode
export function collectCar (params) {
    return request({
      url: '/collectProduct/web/asyncSend',
      method: 'post',
      params
    })
  }
// 购物车修改数量 
export function updateQuantity (params) {
    return request({
      url: '/shoppingCart/web/updateQuantity',
      method: 'post',
      params
    })
  }
  //支付页订单预览信息
export function previewOrder (params) {
    return request({
      url: '/order/web/previewOrder',
      method: 'post',
      data:params
    })
  }
  export function previewOrders (params) {
    return request({
      url: '/order/web/previewOrders',
      method: 'post',
      data:params
    })
  }
//支付页用户地址信息
export function UserAddress (params) {
    return request({
      url: '/UserAddress/selectUserAddressByUserID',
      method: 'post',
      params,
    })
  }
  //购物车猜你喜欢
  export function PageIndexProduct (params,data) {
    return request({
      url: '/product/web/PageIndexProduct',
      method: 'post',
      params,
      data,//{appcode:cbzx}
    })
  }
//   product/web/findByCode
export function findByCode (params) {
    return request({
      url: '/product/web/findByCode',
      method: 'post',
      params,//{productCode:0000,token:0000}
    })
  }
//  productCode: 7532359460490
export function listResourceInfo (params) {
    return request({
      url: '/productResource/web/listResourceInfo',
      method: 'get',
      params,//{productCode:0000,token:0000}
    })
  }
//   inventory/web/selectByCabpno
export function selectByCabpno (params) {
    return request({
      url: '/inventory/web/selectByCabpno',
      method: 'get',
      params,//{cabpno: 25966,token:0000}
    })
  }
  /** 样书申请 */
  export function BookApply (params,data) {
   return request({
     url: '/teacherBookApply/web/save',
     method: 'post',
     params: params,
     data: data
   })
 }
  /** 购物车数量统计 */
  export function countShoppingCart (params) {
    return request({
      url: '/shoppingCart/web/countShoppingCart',
      method: 'get',
      params: params
    })
  }


// WEBPACK FOOTER //
// ./src/api/car.js